// En dev (npm run dev, via Vite), le backend tourne à part sur localhost:7881.
// En build de prod, IIS reverse-proxy /api vers le backend Node.
// On se base sur le mode Vite (fiable quelle que soit l'URL utilisée pour
// accéder au serveur de dev : localhost, 127.0.0.1, IP réseau, etc.),
// plutôt que sur window.location.hostname.
export const API_URL = import.meta.env.DEV
  ? "http://localhost:7881/api"
  : "/api";
